import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/brandsConstants';

const initialState = {
  brands: [],
  brand: null,
  loading: true,
  pageable: {
    totalPages: 1,
    last: true,
    first: true,
    size: 0,
    number: 0,
    totalElements: 0,
  },
  search: {
    search: '',
    page: 0,
    size: 10,
  },
};

const brandsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_BRANDS:
      return {
        ...initialState,
      };
    case types.CLEAR_SELECTED_BRAND:
      return {
        ...state,
        brand: null,
      };
    case types.GET_BRANDS_SUCCESS:
      return {
        ...state,
        loading: false,
        brands: payload.data,
        pageable: payload.pageable,
      };
    case types.GET_BRANDS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_BRANDS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SELECT_BRAND:
      return {
        ...state,
        brand: payload,
      };
    case types.SET_BRANDS_PAGE_SIZE:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          size: payload,
        },
      };
    case types.SET_BRANDS_SEARCH:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          search: payload,
        },
      };
    case types.NEXT_BRANDS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page + 1,
        },
      };
    case types.PREV_BRANDS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page - 1,
        },
      };
    default:
      return state;
  }
};

export default brandsReducer;
